import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "productDimension",
})
export class ProductDimensionPipe implements PipeTransform {
  transform(value: any, ...args: unknown[]): string {
    if (value?.metalList?.length > 1) {
      return "MIX_PRODUCT";
    } else if (value?.metalList?.length == 1) {
      return value?.metalList[0]?.dimensions;
    } else if(value?.dimensions){
      return value?.dimensions
    }else{
      return ""
    }
  }
}
